export default __webpack_public_path__ + "static/media/video.2d29ac4c.mp4";